import React from "react";
import { Link } from "react-router-dom";

const CancelPage = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Payment Cancelled ❌</h1>
      <p>Your payment was cancelled. You can try again anytime.</p>
      <Link to="/workshops">Back to workshops</Link>
    </div>
  );
};

export default CancelPage;
